import './Spinner.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Accessible label — required, since a spinner conveys no information without one. */
  label: string;
}

/** Loading indicator. Per design-system/patterns.md's "mandatory state set". */
export function Spinner({ size = 'md', label }: SpinnerProps) {
  return (
    <span role="status" className={`dpr-spinner dpr-spinner--${size}`} aria-label={label} />
  );
}
